import {ImmutableObject} from "../../utils/immutableObject";
import { ProcessingMode } from "./processingmode";

export class ExtraFee extends ImmutableObject {
    constructor(
        public readonly id?: string,
        public readonly uniteAmount?: string,
        public readonly percentage?: string,
        public readonly type?: string,
        public readonly defaultChecked?: boolean,
        public readonly country?: string,
        public readonly label?: string,
        public readonly processingMode?: ProcessingMode,
        public readonly role?: string,
        public readonly serviceCode?: string,
        public readonly checked?: boolean,
        public readonly quantity?: number,
        public readonly totalAmount?: string
    ) {
        super();
    }

}

export interface ExtraFeePayload {
    extraFeeId?: string;
    label?: string;
    processingMode?: ProcessingMode;
    type?: string;
    uniteAmount?: string;
    percentage?: string;
    serviceId?: string;
    quantity?: number;
    totalAmount?: string;
}

export function toExtraFeePayload(extraFee: ExtraFee): ExtraFeePayload {
    return {
        extraFeeId: extraFee.id,
        label: extraFee.label,
        processingMode: extraFee.processingMode,
        type: extraFee.type,
        uniteAmount: extraFee.uniteAmount,
        percentage: extraFee.percentage,
        quantity: extraFee.quantity,
        totalAmount: extraFee.totalAmount
    };
}
